import { createSelector } from 'reselect'

import { selectJBPSettings } from './selectJBPSettings'

export const selectJBPSettingsActualsSync = createSelector(
  [selectJBPSettings],
  ({ fDateActuals, fYearActuals, fQuarterActuals, fQuarterActualsPercentage }) => ({
    fDateActuals,
    fYearActuals,
    fQuarterActuals,
    fQuarterActualsPercentage,
  })
)
